import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormik } from 'formik';

import { FProgressBar } from '../../../../../../components/base';
import {
  EducationFields,
  mapEducationInfoToValues,
  useFormReadOnly,
  useSaveEducationFieldOnBlur,
} from '../../../../../common';
import { EDUCATION_FORM_BOX_SX } from '../styles';
import { EDUCATION_FORM_SCHEMA } from '../validationSchema';

import type { EducationInfoSectionProps } from './types';

export default function EducationInfoSection({
  educationInfo,
  disabled,
  isUpdating,
  onUpdate,
}: EducationInfoSectionProps) {
  const readOnly = useFormReadOnly();
  const initialValues = useMemo(() => mapEducationInfoToValues(educationInfo), [educationInfo]);
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: EDUCATION_FORM_SCHEMA,
    onSubmit: () => undefined,
  });
  const { saveField } = useSaveEducationFieldOnBlur({
    formik,
    initialValues,
    validationSchema: EDUCATION_FORM_SCHEMA,
    onUpdate,
  });

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit} sx={EDUCATION_FORM_BOX_SX}>
      {isUpdating ? <FProgressBar /> : null}
      <EducationFields
        disabled={disabled}
        evaluationDatePicker="month"
        formik={formik}
        readOnly={readOnly}
        richTextDescriptions
        saveField={saveField}
      />
    </Box>
  );
}
